import { makeStyles } from "tss-react/mui"
import { Grid, IconButton } from "@mui/material"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faCalendar, faArrowsRotate } from "@fortawesome/pro-regular-svg-icons"
import { tailwindPalette } from "../../../modules/theme/tailwindPalette"

const useStyles = makeStyles()((theme) => ({
    icon: {
        color: tailwindPalette.sky[500],
        fontSize: "1.5rem",
    },
    iconPosition: {
        position: "absolute",
        right: "-0.25rem",
        bottom: "-0.125rem",
    },
    faArrowsRotate: {
        color: tailwindPalette.slate[600],
        fontSize: "0.875rem",
    },
}))

type StandardDateSwitcherProps = Readonly<{
    handleChange?: () => void
}>

export function StandardDateSwitcherButton({ handleChange }: StandardDateSwitcherProps) {
    const { classes, cx } = useStyles()

    return (
        <IconButton onClick={handleChange} edge="start" color="inherit">
            <Grid position="relative">
                <FontAwesomeIcon icon={faCalendar} className={classes.icon} />
                <FontAwesomeIcon icon={faArrowsRotate} className={cx(classes.faArrowsRotate, classes.iconPosition)} />
            </Grid>
        </IconButton>
    )
}
